module.exports = window["wp"]["viewport"];